export const MEMBER_TIER_EFFECT_TYPE_SINGLE_PURCHASE = 'single_purchase';
export const MEMBER_TIER_EFFECT_TYPE_WITHIN_INTERVAL = 'within_interval';
